import styled from "styled-components";
import {
  theme as _theme,
} from "../../config/theme";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;

  @media (max-width: 592px) {
    & > .inputs-view > .inputs-view-row {
      flex-direction: column !important;
    }

    & > .inputs-view > .inputs-view-row > * {
      width: 100%;
    }
  }

  & > .inputs-view {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.x_medium }px;
    width: 100%;
    min-width: 0;
  }

  & > .inputs-view > .inputs-view-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-width: 0;
    gap: ${({ theme }) => theme.spacing.x_medium }px;
  }

  & > .inputs-view > .inputs-view-row > * {
    min-width: 0;
  }

  & > .inputs-view > .input-view, & > .inputs-view > .inputs-view-row > .input-view {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  & > .inputs-view > .input-view.input-view-checkbox, & > .inputs-view > .inputs-view-row > .input-view.input-view-checkbox {
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing.x_small }px;
  }

  & > .inputs-view > .input-view > .input-icon-button, & > .inputs-view > .inputs-view-row > .input-view > .input-icon-button {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    right: ${({ theme }) => theme.spacing.xx_small }px;
    bottom: ${({ theme }) => theme.spacing.x_medium }px;
  }

  & > .inputs-view > .input-view > .input-label, & > .inputs-view > .inputs-view-row > .input-view > .input-label {
    margin-bottom: ${({ theme }) => theme.spacing.x_small }px;
    color: ${({ theme }) => theme.colors.text.secondary };

    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: ${({ theme }) => theme.typography.weight.semibold };
  }

  & > .inputs-view > .input-view.input-view-checkbox > .input-label, & > .inputs-view > .inputs-view-row > .input-view.input-view-checkbox > .input-label {
    margin-bottom: ${({ theme }) => theme.spacing.none }px;
    cursor: pointer;
  }

  & > .inputs-view > .input-view > input,
  & > .inputs-view > .input-view > textarea,
  & > .inputs-view > .inputs-view-row > .input-view > input,
  & > .inputs-view > .inputs-view-row > .input-view > textarea {
    height: 40px;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding: ${({ theme }) => theme.spacing.xx_small }px;
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
    border: 1px solid ${({ theme }) => theme.colors.border.default };
    color: ${({ theme }) => theme.colors.text.default };

    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;
    background-color: ${({ theme }) => theme.palette.surface };

    transition:
      background-color ${({ theme }) => theme.transitions.fast },
      border-color ${({ theme }) => theme.transitions.fast },
      box-shadow ${({ theme }) => theme.transitions.fast };

    &:hover:not(:disabled) {
      border-color: ${({ theme }) => theme.colors.border.hover };
    }

    &:disabled {
      cursor: not-allowed;
      opacity: .56;
    }
  }

  & > .inputs-view > .input-view > textarea,
  & > .inputs-view > .inputs-view-row > .input-view > textarea {
    height: auto;
    min-height: 96px;
    resize: vertical;
  }

  & > .inputs-view > .input-view.input-view-checkbox > input[type="checkbox"], & > .inputs-view > .inputs-view-row > .input-view.input-view-checkbox > input[type="checkbox"] {
    width: 18px;
    height: 18px;
    min-height: 18px;
    padding: ${({ theme }) => theme.spacing.none }px;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.palette.primary };
  }

  input[type="date"],
  input[type="time"] {
    color-scheme: ${({ theme }) => theme.colors.background !== _theme.light.colors.background ? "dark" : "light"};
  }

  input[type="date"]::-webkit-calendar-picker-indicator, input[type="time"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }

  input[type="date"]::-webkit-datetime-edit, input[type="time"]::-webkit-datetime-edit {
    color: ${({ theme }) => theme.colors.text.default };
  }

  & > .inputs-view > .input-view > input:focus-visible,
  & > .inputs-view > .input-view > textarea:focus-visible,
  & > .inputs-view > .inputs-view-row > .input-view > input:focus-visible,
  & > .inputs-view > .inputs-view-row > .input-view > textarea:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.palette.primary };
    box-shadow: 0 0 0 3px ${({ theme }) => theme.palette.primary }33;
  }

  & > .inputs-view > .input-view > input::placeholder,
  & > .inputs-view > .input-view > textarea::placeholder,
  & > .inputs-view > .inputs-view-row > .input-view > input::placeholder,
  & > .inputs-view > .inputs-view-row > .input-view > textarea::placeholder {
    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;

    color: ${({ theme }) => theme.colors.text.muted };
  }

  & > .inputs-view > .input-view > .input-error-message, & > .inputs-view > .inputs-view-row > .input-view > .input-error-message {
    margin-top: ${({ theme }) => theme.spacing.x_small }px;
    margin-left: ${({ theme }) => theme.spacing.xx_small }px;
    color: ${({ theme }) => theme.colors.error.default };

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }

  & > .actions-view {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
    gap: ${({ theme }) => theme.spacing.x_medium }px;
    margin-top: ${({ theme }) => theme.spacing.x_medium }px;
  }

  & > .actions-view > .actions-view-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    & > div {
      display: flex;
      flex: 1;
    }
  }
`;
